module.exports = __webpack_public_path__ + "img/icon5.82476ec3.svg";